<template>
  <div class="video-background">
    <div class="content">
      <div class="en-title">
        <img src="@/assets/icon/huoyan.png" style="object-fit: contain;height: 60px;
    margin-right: 10px;">
        <span class="huoyan-en">SharpEyes</span>
      </div>
      <div class="title">
      <span class="huoyan-zh" >火眼:</span>  
      <span style="font-size: 28px; font-family: Yuanti TC;">多模态风险内容检测平台</span>
      </div>
<!--      <div class="sub-title">-->
<!--        <span> Multimodal risk content detection platform</span>-->
<!--      </div>-->
      <div class="nav-container box-shadow">
        <nav class="nav">
          <input type="radio" name="nav-item-opt" id="nav-item-opt-1" v-model="selectedNavItem" value="Text">
          <label class="nav-item" for="nav-item-opt-1" @click="changeView('MyText')">
            <img src="@/assets/icon/news.png" alt="icon" class="nav-icon"> 文本
          </label>

          <input type="radio" name="nav-item-opt" id="nav-item-opt-2" v-model="selectedNavItem" value="Pdf">
          <label class="nav-item" for="nav-item-opt-2" @click="changeView('MyPic')">
            <img src="@/assets/icon/image.png" alt="icon" class="nav-icon"> 图片
          </label>

          <input type="radio" name="nav-item-opt" id="nav-item-opt-3" v-model="selectedNavItem" value="Audio">
          <label class="nav-item" for="nav-item-opt-3" @click="changeView('MyAudio')">
            <img src="@/assets/icon/podcast.png" alt="icon" class="nav-icon"> 音频
          </label>
          <div class="tracker"></div>
        </nav>
      </div>
      <div class="content-view">
        <transition name="fade" mode="out-in">
          <component :is="myView" :key="myView"></component>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import MyText from './MyText.vue';
import MyPic from './MyPic.vue';
import MyAudio from './MyAudio.vue';
import MyVideo from './MyVideo.vue';


export default {
  components: {
    MyText,
    MyPic,
    MyAudio,
    MyVideo,

  },
  data() {
    return {
      myView: "MyText",
      activeSwitch: "MyText",
      switches: [
        { label: '文本', value: 'MyText' },
        { label: '图片', value: 'MyPic' },
        { label: '音频', value: 'MyAudio' },
        { label: '视频', value: 'MyVideo' },
      ],
    };
  },
  methods: {
    changeView(value) {
      this.myView = value;
      this.activeSwitch = value;
    },
  },
  mounted() {
    this.$nextTick(() => {
      // 触发第一个按钮的点击事件
      this.changeView('MyText');
      document.getElementById('nav-item-opt-1').click();
    });
  }
}
</script>

<style>
@font-face {

  font-family: 'RocknRoll one';

  src: url('@/assets/font/RocknRollOne-Regular.ttf');

}


@font-face {

  font-family: 'Yuanti TC';

  src: url('@/assets/font/Yuanti TC Regular.ttf');

}
.video-background {
  //background-color: #cedae8;
  background-image: linear-gradient(to top, #f3e7e9 0%, #e3eeff 99%, #e3eeff 100%);
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  transform: scale(1.05);
}

.content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.huoyan-zh {
  font-family: "RocknRoll one";
  font-weight: bolder;
  font-size: 36px;
  color: #1c1983;
}

.huoyan-en {
  font-family: "RocknRoll one";
  font-weight: bolder;
  font-size: 36px;
  margin-top: 12px;
}
.en-title {
  display: flex;
  color: #303133;
  justify-content: center;
  align-items: center;
  font-size: 36px;
  margin-top: 12px;
}
.title {
  //font-family: "RocknRoll one",serif;
  display: flex;
  color: #303133;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  //margin-top: 15px;
  font-family: "Yuanti TC";

  font-weight: bolder;
  height: 6%;
}

.sub-title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #606266;
  margin-bottom: 5px;

}

.content-view {
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.nav-container {
  height: 8%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav {
  position: relative;
  background: white;
  border-radius: 24px;
  height: 36px;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  box-shadow: 0 0 3px 0px #9093994f;
}

.nav > input[type="radio"]:not(:checked) + label:hover {
  background-color: #409eff17; /* 修改为你希望的颜色 */
  /* 如果需要，可以在这里设置悬停时的边框半径，使其与.tracker相同 */
  //border-radius: 24px; /* 与.tracker形状相同 */
}

.nav-item {
  position: relative;
  width: 100px;
  height: 36px;
  font-size: 14px;
  color: #5080ef;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: color .3s ease-in-out,background-color .3s ease-in-out;
  z-index: 2;
  border-radius: 24px;
}


.nav-icon {
  position: relative;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  z-index: 3;
}

.nav > input[type="radio"] {
  width: 0;
  height: 0;
  opacity: 0;
}

.nav > input[type="radio"]:checked + label {
  color: white;
}

.tracker {
  width: 105px;
  height: 36px;
  background: #5080ef;
  z-index: 0;
  position: absolute;
  left: 8px;
  top: 4px;
  border-radius: 24px;
  transition: transform .3s ease-in-out;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

/* 初始选项选中时的跟踪器位置 */
#nav-item-opt-1:checked ~ .tracker {
  transform: translateX(0);
}

/* 第二个选项选中时的跟踪器位置 */
#nav-item-opt-2:checked ~ .tracker {
  transform: translateX(calc(105px));
}

/* 第三个选项选中时的跟踪器位置 */
#nav-item-opt-3:checked ~ .tracker {
  transform: translateX(calc(105px * 2));
}
</style>
